import {isObject} from "vue-cli-plugin-i18n/utils";
import Swal from "sweetalert2";

export function prepareApiParams(params) {
    for (const key in params) {
        const param = params[key];
        if (Array.isArray(param)) {
            for (const keyParamArray in param) {
                if (isObject(param[keyParamArray]) && param[keyParamArray].hasOwnProperty('id'))
                    param[keyParamArray] = param[keyParamArray].id;
            }
        } else if (isObject(param) && param.hasOwnProperty('id')) {
            params[key] = param.id;
        }
    }

    return params;
}

export function getFromJsonCollection(searchParams, Jsoncollection) {
    let results = [];

    for (const JsonObjectId in Jsoncollection) {
        const JsonObject = Jsoncollection[JsonObjectId];
        let shouldMatch = 0;
        let actuallyMatched = 0;

        for (const searchField in searchParams) {
            shouldMatch++;

            if (JsonObject.hasOwnProperty(searchField) && JsonObject[searchField] === searchParams[searchField]) {
                actuallyMatched++;
            }
        }

        if (actuallyMatched === shouldMatch)
            results.push(JsonObject);
    }

    return results;
}

export function catchApiErrors(error) {
    let errors;
    try {
        if (error.response.data) {
            if (error.response.data.message && error.response.data.message !== "")
                errors = error.response.data.message;
            else
                errors = error.response.status + ' '+ error.response.statusText;

            if (error.response.data.errors) {
                errors += '<div class="text-left mt-2"><ul class="list-unstyled">';
                for (const errorField in error.response.data.errors)
                    errors += `<li><strong>${errorField} :</strong> ${error.response.data.errors[errorField]}</li>`;
                errors += '</ul></div>';
            }
        } else if (error.message && error.message !== "")
            errors = error.message;
        else
            errors = error;
    } catch (e) {
        errors = e;
        errors += '<br>' + error;
    }

    Swal.fire({
        icon: 'error',
        title: 'Oops...',
        html: errors,
    });
}

export function getImagePath(item, thumbnail) {
    try {
        let imageNameFull = item.Image;
        let imageNameSplited = imageNameFull.split('.');
        let imageName = imageNameSplited[0];

        /*
                return [{
                    src: require(`@/assets/images/pages/${annee}/${thumbnails ? 'thumbnails' : 'images'}/${imageNameFull}`),
                    title: imageName
                }];
        */
        return [{
            src: '/api/pages/' + item.CodePageAlbum + '/' + (thumbnail ? 'thumbnail' : 'image'),
            title: imageName
        }];


    } catch (e) {
        return [{
            src: require(`@/assets/images/missing-img.svg`),
            title: 'missing-img'
        }];
    }
}

export function truncate(text, length, clamp) {
    clamp = clamp || '...';
    let node = document.createElement('div');
    node.innerHTML = text;
    const content = node.textContent;
    return content.length > length ? content.slice(0, length) + clamp : content;
}



export function dateToString(date) {
    let dateFull = '';

    if (date) {
        if (date.day)
            dateFull += date.day;
        if (date.month)
            dateFull += (dateFull !== '' ? '/' : '') + date.month;
        if (date.year)
            dateFull += (dateFull !== '' ? '/' : '') + date.year;
    }

    return dateFull;
}

export function toPlural(word) {
    if (word[word.length -1] === "y")
        return word.slice(0, -1) + "ies";

    return word +"s";
}